module.exports = __webpack_public_path__ + "assets/img/28_1609_big.fe1c662e.jpg";